export default __webpack_public_path__ + "static/media/HaveTrailer.a743a9e8.svg";